import script from "./NftItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./NftItem.vue?vue&type=script&setup=true&lang=ts"

import "./NftItem.vue?vue&type=style&index=0&id=14856387&scoped=true&lang=scss"
/* custom blocks */
import block0 from "@/language/json/nft/info.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FNFT%2FNftItem.vue"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14856387"]])

export default __exports__